import React from 'react'
import { SkeltonStyle } from './WidgetsLoader.style'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import {
  ContainerTradeBlotterAgGridTable,
  ContainerActivityBlotterAgGridTable,
  ContainerRatesAgGridTable,
  ContainerRatesWidget,
  ContainerTradeBlotterWidget,
  PaperStyle
} from '../../TradeBlotter.style'

const WidgetsLoader = ({ preferences }) => {
  if (preferences.tradeBlotter && preferences.activityBlotter && preferences.rates) {
    return (
      <PaperStyle>
        <Grid container spacing={2} height={'100%'} display={'flex'}>
          <ContainerTradeBlotterWidget item xl={9.6} lg={9} md={8} sm={12} xs={12}>
            <ContainerActivityBlotterAgGridTable>
              <SkeltonStyle variant="rounded" height={'100%'} width={'100%'} />
            </ContainerActivityBlotterAgGridTable>
            <ContainerTradeBlotterAgGridTable style={{ marginTop: '10px' }}>
              <SkeltonStyle variant="rounded" height={'100%'} width={'100%'} />
            </ContainerTradeBlotterAgGridTable>
          </ContainerTradeBlotterWidget>
          <ContainerRatesWidget item xl={2.4} lg={3} md={4} sm={12} xs={12}>
            <ContainerRatesAgGridTable>
              <SkeltonStyle variant="rounded" height={'100%'} width={'100%'} />
            </ContainerRatesAgGridTable>
          </ContainerRatesWidget>
        </Grid>
      </PaperStyle>
    )
  }
  if (preferences.tradeBlotter && preferences.activityBlotter && !preferences.rates) {
    return (
      <PaperStyle>
        <Grid container spacing={2} height={'100%'} display={'flex'}>
          <ContainerTradeBlotterWidget item xl={12} lg={12} md={12} sm={12} xs={12}>
            <ContainerActivityBlotterAgGridTable>
              <SkeltonStyle variant="rounded" height={'100%'} width={'100%'} />
            </ContainerActivityBlotterAgGridTable>
            <ContainerTradeBlotterAgGridTable style={{ marginTop: '10px' }}>
              <SkeltonStyle variant="rounded" height={'100%'} width={'100%'} />
            </ContainerTradeBlotterAgGridTable>
          </ContainerTradeBlotterWidget>
        </Grid>
      </PaperStyle>
    )
  }
  if (preferences.rates && preferences.tradeBlotter && !preferences.activityBlotter) {
    return (
      <PaperStyle>
        <Grid container spacing={2} height={'100%'} display={'flex'}>
          <ContainerTradeBlotterWidget item xl={9.6} lg={9} md={8} sm={12} xs={12}>
            <ContainerTradeBlotterAgGridTable>
              <SkeltonStyle variant="rounded" height={'100%'} width={'100%'} />
            </ContainerTradeBlotterAgGridTable>
          </ContainerTradeBlotterWidget>
          <ContainerRatesWidget item xl={2.4} lg={3} md={4} sm={12} xs={12}>
            <ContainerRatesAgGridTable>
              <SkeltonStyle variant="rounded" height={'100%'} width={'100%'} />
            </ContainerRatesAgGridTable>
          </ContainerRatesWidget>
        </Grid>
      </PaperStyle>
    )
  }
}

WidgetsLoader.propTypes = {
  preferences: PropTypes.object
}

export default WidgetsLoader
